import {setConfig} from './core/config';

let inited = false;

export function initDriveApp(config: any) {
  if (inited) return;
  inited = true;

  setConfig(config);
}